export default __webpack_public_path__ + "static/media/red-ribbon.6e8ebfbe.png";